import { render, staticRenderFns } from "./GLforMngtCommentary.vue?vue&type=template&id=2e3021cc&scoped=true"
import script from "./GLforMngtCommentary.vue?vue&type=script&lang=js"
export * from "./GLforMngtCommentary.vue?vue&type=script&lang=js"
import style0 from "./GLforMngtCommentary.vue?vue&type=style&index=0&id=2e3021cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3021cc",
  null
  
)

export default component.exports